import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export interface Faq {
  question: string;
  answer: string;
}

// schema.org FAQPage data to put in a page's JSON-LD
export const faqSchema = (faqs: Faq[]) => ({
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: { '@type': 'Answer', text: faq.answer },
  })),
});

const FaqAccordion: React.FC<{ faqs: Faq[] }> = ({ faqs }) => (
  <>
    {faqs.map((faq, index) => (
      <Accordion key={faq.question} sx={{ mb: 2 }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`faq-${index}-content`}
          id={`faq-${index}-header`}
        >
          <Typography variant="h6" component="h3" fontWeight={500}>
            {faq.question}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">{faq.answer}</Typography>
        </AccordionDetails>
      </Accordion>
    ))}
  </>
);

export default FaqAccordion;
